import {getConfigFields, getMaxLengthConstraint, getNotNullConstraint} from '../fields.js'
import {defaultTabIndex, formFieldIds, inputTypes} from '../values.js'

const {hidePhone, postalCode, name, lastName, email, phone} = formFieldIds

const formUserPersonalDataFieldsConfig = [
  getConfigFields[email]({
    customProps: {
      constraints: [getNotNullConstraint({message: 'INSTANT_OFFER.LANDING.EMAIL_IS_REQUIRED'})],
      disabled: true
    }
  }),
  getConfigFields[phone](),
  getConfigFields[hidePhone](),
  getConfigFields[name]({
    customProps: {
      label: 'FORM.CONTACT_NAME_LABEL',
      required: true,
      constraints: [
        getMaxLengthConstraint({value: '30'}),
        getNotNullConstraint({
          message: 'RESERVATION_C2B.USER_FORM.NAME_FIELD_ERROR_TEXT'
        })
      ]
    }
  }),
  {
    id: lastName,
    label: 'SECURE_PAYMENT.FORM_DATA.LAST_NAME_INPUT_LABEL',
    required: false,
    tabIndex: defaultTabIndex,
    type: inputTypes.text,
    constraints: [getMaxLengthConstraint({value: '50'})]
  },
  getConfigFields[postalCode]()
]

export const formUserPersonalDataConfig = {
  fields: formUserPersonalDataFieldsConfig
}
